export const getLinkTarget: (
	event: React.MouseEvent | React.KeyboardEvent,
) => '_blank' | '_self' = (event: React.MouseEvent | React.KeyboardEvent) =>
	isSpecialEvent(event) ? '_blank' : '_self';

/**
 * All code below this comment block is lifted from Linking Platform to match their smart card link click behavior:
 * https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/238b520ec4308da2c86b01cbdd145f141c75d51b/platform/packages/linking-platform/smart-card/src/utils/index.tsx#lines-11:34
 */

const isSpecialEvent = (event: React.MouseEvent | React.KeyboardEvent) =>
	event.isDefaultPrevented() &&
	(isIframe() || isSpecialKey(event) || isSpecialClick(event as React.MouseEvent));

// Slight change from Linking Platform code to add try/catch here
const isIframe = () => {
	try {
		return window.parent !== window;
	} catch {
		// cross-origin parent access throws
		return true;
	}
};

/**
 * Meta key = cmd on mac, windows key on windows
 * Ctrl key on mac by default triggers a right click instead of left click
 * Ctrl key on Windows has the same behaviour of cmd key of mac (open in new tab)
 * Shift key is also a "special" key because the default behavior of Chromium-based browsers is to open the
 * link in a new window; Arc browser has custom logic to show links in its "peek" window when shift is held.
 *
 * `isSpecialKey` on a mouse event on mac with default behaviour should be equivalent to opening in new tab
 * On Windows it will be equivalent to opening a new tab, unless its the Window key that is held
 * in which case typically only a standard clickthrough will occur, this is likely a small portion of events
 */
const isSpecialKey = (event: React.MouseEvent | React.KeyboardEvent) =>
	event.metaKey || event.ctrlKey || event.shiftKey;

const isSpecialClick = (event: React.MouseEvent) => event.button === 1;
